import { Dispatch } from 'redux'
import { checkUnsavedChanges } from '../configurationActions'
import { configsActions } from '../../slices/configsSlice'

export const initEmptyData = ({ name, schema, path, type}: {
  name: string,
  path: string[],
  schema: any,
  type?: any
}) => {
    return (dispatch: Dispatch) => {
        dispatch(configsActions.initEmptyData({ name, schema, path, type }))
        dispatch(checkUnsavedChanges(path[0]))
    }
}

export const dateTimeActions = {
  modify(componentState: any, path: string[], data: any, name: string) {
    return (dispatch: Dispatch) => {
      dispatch(configsActions.modifyDateTime({ componentState, path, data, name }))
    }
  },
}

export const inputActions = {
  modify(
    componentState: any,
    path: string[],
    data: any,
    name: string,
    type?: string,
    isEmptyAsNull?: boolean
  ) {
    return (dispatch: Dispatch) => {
      dispatch(configsActions.modifyInput({ componentState, path, data, name, type, isEmptyAsNull }))
      dispatch(checkUnsavedChanges(path[0]))
    }
  },
}

export const enumActions = {
  modify(componentState: any, path: string[], data: any) {
    return (dispatch: Dispatch) => {
      dispatch(configsActions.modifyEnum({ componentState, path, data }))
      dispatch(checkUnsavedChanges(path[0]))
    }
  },
}

export const flagActions = {
  modify(componentState: any, path: string[], data: any) {
    return (dispatch: Dispatch) => {
      dispatch(configsActions.changeFlag({ componentState, path, data }))
      dispatch(checkUnsavedChanges(path[0]))
    }
  },
}

export const blockDictActions = {
  addItem(path: string[], data: any, item: any) {
    return (dispatch: Dispatch) => {
      dispatch(
          configsActions.addBlockDictionaryItem( { path, data, item })
      )
    }
  },
  deleteItem(path: string[], data: any, dictionaryKey: string) {
    return (dispatch: Dispatch) => {
      dispatch(configsActions.deleteBlockDictionaryItem({ path, data, dictionaryKey }))
      dispatch(checkUnsavedChanges(path[0]))
    }
  },
}
